<div class="search-panel">
  <div class="search-box-wrapper" [class.expanded]="expanded">
    <div class="search-box-container">
      <!-- Search Icon -->
      <img class="search-icon" src="/assets/images/icons/search.svg" alt="search-icon" (click)="onFocus()">

      <!-- Search Input -->
      <input #searchInput id="global-search-input" type="text" maxlength="30" [(ngModel)]="searchQuery" (focus)="onFocus()" (input)="onInputChange()" (ngModelChange)="onSearchChange($event)" (keydown)="preventLeadingSpace($event)" 
        class="form-control search-input" [placeholder]="('lbl_search' | translate)" />

      <!-- Close Icon (shown only if there's text) -->
      <button id="global-search-clear" class="btn search-close-btn" *ngIf="searchQuery" (click)="onClear()" aria-label="Clear search">
        <img src="/assets/images/icons/close-2.svg" alt="close-search">
      </button>
    </div>

    <!-- Dropdown Panel -->
    <div id="global-search-dropdown" class="dropdown-panel" *ngIf="showDropdown" [@dropdownAnim]>
      <div class="dropdown-content">
        <div [ngSwitch]="searchTabSelection" class="content-area">
    
          <!-- All Category -->
          <ng-container *ngSwitchCase="searchTabSelections.All">
            <!-- Loader shown while loading -->
            <ng-container *ngIf="isLoadingResults; else resultsOrNoResults">
              <div class="search-loader">
                <div class="loading-base"></div>
              </div>
            </ng-container>
            <ng-template #resultsOrNoResults>
              <div class="results" *ngIf="filteredResults?.length; else noResults">
                <div class="category-filter-bar">
                  <div class="left-filters">
                    <button class="btn filter-btn v-hidden">All</button>
                  </div>
                  <div class="result-count">{{ "lbl_results" | translate }} : {{ filteredResults.length }}</div>
                </div>
                <div class="results-list">
                  <div class="result-item" *ngFor="let item of filteredResults" appClickAndDoubleClick (singleClick)="onItemClick(item)" (doubleClick)="onDoubleClick(item)"
                    [class.selected]="item.id === selectedItem?.id && item.category === selectedItem?.category">
                    <span [innerHTML]="highlightMatch(item.name, searchQuery)"></span>
                    <span class="category">({{ "GlobalSearch.lbl_" + item.category | translate }})</span>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template #noResults>
              <div class="no-results" *ngIf="searchQuery && searchQuery?.length">
                <p class="no-results-text">{{ "lbl_no_results_found" | translate }}</p>
              </div>
            </ng-template>
          </ng-container>
    
          <!-- Member Category -->
          <ng-container *ngSwitchCase="searchTabSelections.Member">
            <!-- Loader shown while loading -->
            <ng-container *ngIf="isLoadingResults; else resultsOrNoResults">
              <div class="search-loader">
                <div class="loading-base"></div>
              </div>
            </ng-container>
            <ng-template #resultsOrNoResults>
              <div *ngIf="filteredResults?.length; else noResults">
                <div class="category-filter-bar">
                  <div class="left-filters">
                    <button class="btn filter-btn" *ngFor="let filter of memberSubFilters" [id]="'global-search-member-filter-' + filter.key"
                      [class.active]="memberSubFilter.includes(filter.key)" (click)="toggleMemberSubFilter(filter.key)">
                      {{ filter.label | translate }}
                    </button>
                  </div>
                  <div class="result-count">{{ "lbl_results" | translate }} : {{ filteredResults.length }}</div>
                </div>
    
                <div class="results-list">
                  <div class="result-item" *ngFor="let item of filteredResults" appClickAndDoubleClick (singleClick)="onItemClick(item)" (doubleClick)="onDoubleClick(item)"
                    [class.selected]="item.id === selectedItem?.id && item.category === selectedItem?.category">
                    <span class="gender-dot" *ngIf="memberSubFilter.includes('gender') && item.filters.gender"
                      [ngClass]="getGenderClass(item.filters.gender)"></span>
                    <span [innerHTML]="highlightMatch(item.name, searchQuery)"></span>
                  </div>
                </div>
              </div>
              <ng-template #noResults>
                <div class="no-results" *ngIf="searchQuery && searchQuery?.length">
                  <p class="no-results-text">{{ "lbl_no_results_found" | translate }}</p>
                </div>
              </ng-template>
            </ng-template>
          </ng-container>
    
          <!-- family Category -->
          <ng-container *ngSwitchCase="searchTabSelections.Family">
            <!-- Loader shown while loading -->
            <ng-container *ngIf="isLoadingResults; else resultsOrNoResults">
              <div class="search-loader">
                <div class="loading-base"></div>
              </div>
            </ng-container>
              <ng-template #resultsOrNoResults>
                  <div class="category-filter-bar">
                    <div class="left-filters">
                      <button class="btn filter-btn" *ngFor="let filter of familySubFilters" [id]="'global-search-family-filter-' + filter.key"
                        [class.active]="familySubFilter === filter.key" (click)="onFamilySubFilterChange(filter.key,true)">
                        <span *ngIf="filter.key !== 'All'" class="gender-dot" [ngClass]="{
                                          'male': filter.key === 'Male',
                                          'female': filter.key === 'Female',
                                          'unknown': filter.key === 'Unknown'
                                        }"></span>
                        {{ filter.label | translate }}
                      </button>
                    </div>
                    <div class="result-count">{{ "lbl_results" | translate }} : {{ familyResults.length }}</div>
                  </div>
      
                  <div class="results-list">
                    <ng-container *ngIf="familyResults.length > 0; else noResults">
                    <div class="container pb-2">
                      <div class="row fam-header">
                        <div class="col-md-6">Partner 1</div>
                        <div class="col-md-6">Partner 2</div>
                      </div>
              
                      <div class="result-item row mb-2" *ngFor="let couple of familyResults" appClickAndDoubleClick (singleClick)="onItemClick(couple)" (doubleClick)="onDoubleClick(couple)"
                      [class.selected]="couple.familyId === selectedItem?.familyId && couple.category === selectedItem?.category">
                        <div class="col-md-6 d-flex align-items-center">
                          <span class="gender-dot me-2" [ngClass]="getGenderClass(couple.partner1.gender)"></span>
                          <span class="partner ellipsis" [innerHTML]="highlightMatch(couple.partner1.name, searchQuery)"></span>
                        </div>
                        <div class="col-md-6 member-2 d-flex align-items-center">
                          <span class="gender-dot me-2" [ngClass]="getGenderClass(couple.partner2.gender)"></span>
                          <span class="partner ellipsis" [innerHTML]="highlightMatch(couple.partner2.name, searchQuery)"></span>
                        </div>
                      </div>
                    </div>
                    </ng-container>
                    <ng-template #noResults>
                        <div class="no-results" *ngIf="searchQuery && searchQuery?.length">
                          <p class="no-results-text">{{ "lbl_no_results_found" | translate }}</p>
                        </div>
                      </ng-template>
                  </div>
              </ng-template>
            </ng-container>
    
          <!-- Location Category -->
          <ng-container *ngSwitchCase="searchTabSelections.Location">
            <!-- Loader shown while loading -->
            <ng-container *ngIf="isLoadingResults; else resultsOrNoResults">
              <div class="search-loader">
                <div class="loading-base"></div>
              </div>
            </ng-container>
            <ng-template #resultsOrNoResults>
              <div *ngIf="filteredResults?.length; else noResults">
                <div class="category-filter-bar">
                  <div class="left-filters">
                    <button class="btn filter-btn v-hidden">All</button>
                  </div>
                  <div class="result-count">{{ "lbl_results" | translate }} : {{ filteredResults.length }}</div>
                </div>
    
                <div class="results-list">
                  <div class="result-item d-flex align-items-center" *ngFor="let item of filteredResults"
                    appClickAndDoubleClick (singleClick)="onItemClick(item)" (doubleClick)="onDoubleClick(item)" 
                    [class.selected]="item.id === selectedItem?.id && item.category === selectedItem?.category" >
                    <button class="pin-btn" type="button" aria-label="View location">
                      <img
                        [src]="(item.filters.isLocationAvailable)  ? '/assets/images/location-active.svg' : '/assets/images/location-inactive.svg'"
                        alt="location" class="location-icon" (click)="openGoogleMap(item)">
                    </button>
                    <span class="location-name" [innerHTML]="highlightMatch(item.name, searchQuery)"></span>
                  </div>
                </div>
              </div>
            </ng-template>
    
            <ng-template #noResults>
              <div class="no-results" *ngIf="searchQuery && searchQuery?.length">
                <p class="no-results-text">{{ "lbl_no_results_found" | translate }}</p>
              </div>
            </ng-template>
          </ng-container>
    
          <!-- Source Category -->
          <ng-container *ngSwitchCase="searchTabSelections.Source">
            <!-- Loader shown while loading -->
            <ng-container *ngIf="isLoadingResults; else resultsOrNoResults">
              <div class="search-loader">
                <div class="loading-base"></div>
              </div>
            </ng-container>
            <ng-template #resultsOrNoResults>
              <div *ngIf="filteredResults?.length; else noResults">
                <div class="category-filter-bar">
                  <div class="left-filters">
                    <button class="btn filter-btn v-hidden">All</button>
                  </div>
                  <div class="result-count">{{ "lbl_results" | translate }} : {{ filteredResults.length }}</div>
                </div>
    
                <div class="results-list">
                  <div class="result-item d-flex align-items-center" *ngFor="let item of filteredResults"
                    appClickAndDoubleClick (singleClick)="onItemClick(item)" (doubleClick)="onDoubleClick(item)"  
                    [class.selected]="item.id === selectedItem?.id && item.category === selectedItem?.category">
                    <span class="source-name" [innerHTML]="highlightMatch(item.name, searchQuery)"></span>
                  </div>
                </div>
              </div>
            </ng-template>
    
            <ng-template #noResults>
              <div class="no-results" *ngIf="searchQuery && searchQuery?.length">
                <p class="no-results-text">{{ "lbl_no_results_found" | translate }}</p>
              </div>
            </ng-template>
          </ng-container>
    
          <!-- Multimedia Category -->
          <ng-container *ngSwitchCase="searchTabSelections.Multimedia">
            <!-- Loader shown while loading -->
            <ng-container *ngIf="isLoadingResults; else resultsOrNoResults">
              <div class="search-loader">
                <div class="loading-base"></div>
              </div>
            </ng-container>
            <ng-template #resultsOrNoResults>
              <div>
                <div class="category-filter-bar">
                  <div class="left-filters">
                    <button class="btn filter-btn" *ngFor="let filter of multimediaSubFilters" [id]="'global-search-media-filter-' + filter.key"
                      [class.active]="multimediaSubFilter === filter.key" (click)="onMultimediaSubFilterChange(filter.key,true)">
                      {{ filter.label | translate }}
                    </button>
                  </div>
                  <div class="result-count">{{ "lbl_results" | translate }} : {{ filteredResults?.length }}</div>
                </div>
                <ng-container *ngIf="filteredResults?.length; else noResults">
                   <div class="results-list">
                  <div class="result-item d-flex align-items-center" *ngFor="let item of filteredResults"
                    appClickAndDoubleClick (singleClick)="onItemClick(item)" (doubleClick)="onDoubleClick(item)"  
                    [class.selected]="item.id === selectedItem?.id && item.category === selectedItem?.category">
                    <span [innerHTML]="highlightMatch(item.name, searchQuery)"></span>
                    <span class="category" *ngIf="multimediaSubFilter === 'All' && item.filters?.fileType">
                      ({{"GlobalSearch.lbl_" + MultimediaFileType[item.filters?.fileType] | translate }})
                    </span>
                  </div>
                </div>
                </ng-container>
              </div>
            </ng-template>
    
            <ng-template #noResults>
              <div class="no-results multimedia" *ngIf="searchQuery && searchQuery?.length">
                <p class="no-results-text">{{ "lbl_no_results_found" | translate }}</p>
              </div>
            </ng-template>
          </ng-container>
    
        </div>
    
        <div class="bottom-area">
          <hr class="divider" />
          <div class="filter-buttons">
            <button class="btn btn-outline-light" [id]="'global-search-tab-' + tab.value" [class.active]="tab.value === searchTabSelection"
              *ngFor="let tab of tabOptions" (click)="selectTab(tab.value)">
              {{ tab.label | translate }}
            </button>
          </div>
        </div>
    
      </div>
    
      <!-- Description Panel -->
      <div #descPanel id="global-search-details" class="description-panel" *ngIf="selectedItem" [@fadeSlideInOut]="animationState">
        <div class="description-panel--inner" [@descriptionContentAnim]="animationState"
          (@descriptionContentAnim.done)="onAnimationDone()">
          <div class="fields">
            <div class="field" *ngFor="let field of fields">
              <div class="name" [ngStyle]="{ 'margin-left': field.indent ? '2rem' : '0' }">
                {{ field.name }}
              </div>
              <div class="value" [ngClass]="{'full-length': selectedItem.category == 'Location' || selectedItem.category == 'Source', 'child-name': field.indent}">{{ field.value }}</div>
            </div>
          </div>
    
          <div class="avatar" *ngIf="selectedItem.avatarUrl">
            <img [src]="selectedItem.avatarUrl" alt="avatar" [ngClass]="{
                        'member-avatar': selectedItem.avatarStyle === 'member',
                        'multimedia-thumbnail': selectedItem.avatarStyle === 'multimedia'
                      }"
                      (error)="selectedItem.avatarUrl = '/assets/images/defaults/default-cracked-file.svg'" />
          </div>
        </div>
      </div>
    </div>

  </div>
</div>